<template>
	<v-card class="flex pa-0" v-if=loaded>
		<v-toolbar flat color="grey lighten-4">
		    <v-toolbar-title class="pl-3 grey--text text--darken-4">Distribuzione appuntamenti</v-toolbar-title>
		    <v-spacer></v-spacer>
			<v-toolbar-items>
		        <v-btn @click="showTable = !showTable" slot="activator" icon>
		            <v-icon color="grey darken-1">storage</v-icon>
		        </v-btn>
			</v-toolbar-items>
		</v-toolbar>
		<v-divider></v-divider>
		
		<v-layout v-if="loaded" row wrap px-4 py-2>
			<v-flex xs6 sm6 md3 lg2 py-0 pr-3>
				<v-select 
					:items="fieldsset.year.options"
					v-model="model['year']"
					persistent-hint
					hint="Anno"
					single-line
					dense
					box
				></v-select>
			</v-flex>
		</v-layout>

		<v-layout v-if="!showTable" row wrap>
			<v-flex xs12>
				<stacked-columns-chart v-if="loadedData"
					:chart-data="chartData" 
				></stacked-columns-chart>
			</v-flex>
		</v-layout>
		<v-data-table v-else class="w100p"
			:items="tableData"
			:headers="tableHeaders"
			hide-actions>
			<template slot="items" slot-scope="props">
				<tr class="cursor-pointer">
					<template v-for="(header, h) in tableHeaders">
						<td :key="h">
							{{ props.item[header.value] }}
						</td>
					</template>
				</tr>
			</template>
		</v-data-table>
	</v-card>
</template>

<script>
	
	import Vue from 'vue'
	import StackedColumnsChart from '@/components/statistic/StackedColumnsChart'
	
    export default {
        name: 'events-distribution',
        components: {
            StackedColumnsChart
        },
        props: {},
		data() {
			return {
                loaded: false,
                loadedData: false,
                showTable: false,
                fieldsset: {},
                chartData: [],
				model: {},
				infoData: {},
				tableHeaders: [],
				tableData: []
			}
        },
        watch: {
            model: {
                handler() {
                    this.getData()
                },
                deep: true,
            },
        },
        
        created() {
			this.axios.get('events-distribution-info').then(response => {
				// get body data
				this.infoData = response.data.info
				this.fieldsset = response.data.info.fields
				_.forEach(this.fieldsset, (value, key) => {
				    if(value.default) {
				        Vue.set(this.model, value.key, value.default)
				    }
				})
				this.loaded = true
			}, response => {
				// error callback
			})
		},
        
        methods: {
			getData() {
				this.axios.post('events-distribution', this.model).then(response => {
					this.chartData = []
					this.chartData = response.data.data
					this.tableData = response.data.datatable
					this.tableHeaders = response.data.headers
                    this.loadedData = true
                    
                    this.$store.commit('endProgress')

				}, response => {
					// error callback
				})
            },
            
			total(data) {
				let total = 0
				_.forEach(data, (value, key) => {
					if(key != 'year')
						total += value
				}) 
				return total
			}
        },
    }
</script>

<style>
</style>